// src/views/VocabularyHubView.jsx
import React from 'react';
import { ArrowLeft, Zap, Lock, Gift, Star, BookOpen, X } from 'lucide-react';
import vocabularyData from '../data/vocabulary';
import { playSound } from '../utils/sounds';
import { useVocabularyHub } from '../hooks/useVocabularyHub';
import Mascot from '../components/Mascot';

// ✅ Componentes modularizados
import CategoryDropdown from '../components/hub/CategoryDropdown';
import RewardModal from '../components/modals/RewardModal';
import XpErrorModal from '../components/modals/XpErrorModal';
import SetViewerModal from '../components/modals/SetViewerModal';
import ConfettiEffect from '../components/effects/ConfettiEffect';

export default function VocabularyHubView({
  setView,
  userProgress,
  onBuyContent,
setActiveModal,
  onStartPractice,
  onStartChallenge,
  mode = 'shop'
}) {
  const CHEST_COST = 500;

  const { states, actions, computed } = useVocabularyHub({
    userProgress,
    vocabularyData,
    mode,
    CHEST_COST
  });

  const { 
    viewingSet, 
    purchaseSuccess, xpErrorModal, selectedFilter, currentSkin 
  } = states;
// Dentro de VocabularyHubView.jsx
const handleSetClick = (set, isOwned) => {
  if (isOwned) {
    // Si ya es suyo, abrimos el visor de palabras
    setViewingSet(set); 
  } else {
    // Si es bloqueado, disparamos el modal de compra global de App.js
    setActiveModal({ 
      type: 'CONFIRM_PURCHASE', 
      data: set // Pasamos el set como itemToBuy
    });
  }
};

  const { 
    setSelectedFilter,  
   setXpErrorModal,  setPurchaseSuccess, setViewingSet,
  } = actions;

  const { filteredSets, moduleStatus } = computed;

  const getMascotCongratulation = () => {
    const phrases = currentSkin.includes('dolly') 
      ? ["¡Qué emoción! Este set es súper cute ✨", "¡A brillar con estas nuevas palabras! 💕"]
      : ["¡Eso es! A darle átomos a ese cerebro 🐾", "¡Nueva data desbloqueada, crack! 😎"];
    return phrases[Math.floor(Math.random() * phrases.length)];
  };
// ✅ DESPUÉS (usa modal global de App.js)
const handleModulePurchase = (moduleId, cost) => {
  setActiveModal({ 
    type: 'CONFIRM_PURCHASE', 
    data: {
      id: `MODULE_${moduleId}`,
      title: `Módulo ${moduleId}`,
      subtitle: 'Desbloquear todos los sets',
      cost: cost,
      emoji: '🔓',
      description: `Accede a todos los sets de vocabulario del Módulo ${moduleId}.`
    }
  });
};
const handleLockedModuleClick = (moduleId) => {
  const cost = 1000; // O calcularlo dinámicamente
  
  setActiveModal({ 
    type: 'CONFIRM_PURCHASE', 
    data: { 
      id: `MODULE_${moduleId}`,
      title: `Módulo ${moduleId}`,
      subtitle: 'Desbloquear todos los sets',
      cost: cost,
      emoji: '🔓',
      description: `Accede a todos los sets de vocabulario del Módulo ${moduleId}.`
    } 
  });
};

  // ✅ Cierre del modal con click fuera (solo para shop)
  const handleOverlayClick = (e) => {
    if (e.target === e.currentTarget && mode === 'shop') {
      setView('lobby');
    }
  };

  const Z_INDEX = {
    SHOP_MODAL: 50,      // ← Modal de tienda (debajo de todo)
    BASE: 1000,
    VIEWER: 1020,
    CHEST_OPENING: 1030,
    PRIZE: 1040,
    ERROR: 1050,
    SUCCESS: 1060
  };

  if (mode === 'library') {
  return (
    <div className="pb-24 animate-in fade-in duration-500 bg-slate-50 min-h-screen">
      {purchaseSuccess && <ConfettiEffect />}

{/* HEADER REFORZADO - Solución a clics y solapamiento */}
<div className="bg-gradient-to-b from-indigo-600 to-indigo-700 pt-10 pb-12 px-6 rounded-b-[3rem] text-white shadow-2xl relative overflow-hidden mb-8">
  {/* Capa de brillo decorativo */}
  <div className="absolute -top-10 -right-10 w-40 h-40 bg-white/10 rounded-full blur-3xl pointer-events-none" />

  <div className="relative flex items-center justify-between min-h-[64px]">
    
    {/* 1. BOTÓN DE RETORNO: Elevado con z-index alto */}
    <div className="z-[110]"> 
      <button 
        onClick={() => setView('lobby')} 
        className="p-3 bg-white/10 backdrop-blur-md border border-white/20 rounded-2xl hover:bg-white/20 transition-all active:scale-90 shadow-lg"
      >
        <ArrowLeft size={24} className="text-white" />
      </button>
    </div>

    {/* 2. TÍTULO: Centrado y con margen lateral para no chocar */}
    <div className="flex-1 text-center px-2">
      <h1 className="text-2xl font-black tracking-tight leading-none drop-shadow-md">
        Mi Biblioteca
      </h1>
      <p className="text-indigo-100/80 font-bold text-[10px] uppercase tracking-[0.2em] mt-1">
        Sets Desbloqueados
      </p>
    </div>

    {/* 3. XP BADGE: Tamaño controlado para evitar encimamiento */}
    <div className="z-[110]">
      <div className="flex items-center gap-1.5 bg-indigo-950/40 backdrop-blur-xl px-3 py-2 rounded-2xl border border-white/10 shadow-inner">
        <Zap size={14} className="text-amber-400" fill="currentColor" />
        <span className="font-black text-sm tabular-nums">
          {userProgress.xp}
        </span>
      </div>
    </div>
  </div>
</div>

      {/* DROPDOWN */}
      <CategoryDropdown 
        selectedFilter={selectedFilter}
        onFilterChange={setSelectedFilter}
        isModuleLocked={computed.isModuleLocked}
        onLockedModuleClick={handleLockedModuleClick}
      />

      {/* ✅ BANNER INFORMATIVO (cuando módulo está bloqueado) */}
      {moduleStatus.isLocked && (
        <div className="mx-6 mb-6 bg-gradient-to-br from-amber-50 to-orange-50 border-2 border-amber-200 rounded-2xl p-5 shadow-md animate-in fade-in slide-in-from-top-3 duration-500">
          <div className="flex items-start gap-3">
            <div className="w-10 h-10 bg-amber-400 rounded-full flex items-center justify-center shrink-0 shadow-md">
              <Lock size={20} className="text-white" />
            </div>
            
            <div className="flex-1">
              <h4 className="text-amber-900 font-black text-sm mb-1">
                🔒 Módulo {selectedFilter} Bloqueado
              </h4>
              <p className="text-amber-700 font-bold text-xs leading-relaxed">
                Completa <span className="text-amber-900 font-black">{moduleStatus.remaining}</span> sets del Módulo {moduleStatus.prevModule} o compra por <span className="text-amber-900 font-black">{moduleStatus.cost} XP</span>
              </p>
            </div>

            <button 
              onClick={() => handleLockedModuleClick(selectedFilter)}
              className="bg-amber-500 hover:bg-amber-600 text-white px-4 py-2 rounded-xl font-black text-xs shadow-md hover:shadow-lg transition-all active:scale-95 shrink-0"
            >
              Desbloquear
            </button>
          </div>

          {/* Barra de progreso */}
          <div className="mt-4 bg-amber-200 rounded-full h-2 overflow-hidden">
            <div 
              className="h-full bg-gradient-to-r from-amber-500 to-orange-500 transition-all duration-1000 rounded-full shadow-sm" 
              style={{ width: `${((5 - moduleStatus.remaining) / 5) * 100}%` }}
            />
          </div>
          <p className="text-amber-600 text-[10px] font-bold mt-1.5 text-right">
            {5 - moduleStatus.remaining} / 5 completados
          </p>
        </div>
      )}

      {/* ✅ CONTENIDO CON BLUR */}
      <div className="px-6 max-w-lg mx-auto relative">
        <div className={`transition-all duration-500 ${moduleStatus.isLocked ? 'blur-sm grayscale opacity-50 pointer-events-none' : ''}`}>
          
          {/* Título dinámico */}
          <h3 className="text-slate-400 font-black text-xs mb-6 flex items-center gap-2 uppercase tracking-[0.2em] px-2">
            <Star size={14} className="text-indigo-500" fill="currentColor" />
            {moduleStatus.isLocked 
              ? `🔒 Módulo ${selectedFilter} Bloqueado` 
              : (selectedFilter === 'library' ? 'Colección Completa' : `Módulo ${selectedFilter}`)
            }
          </h3>
          
          {/* Lista de sets */}
          <div className="space-y-5">
            {filteredSets.map((set) => {
              const isOwned = set.cost === 0 || userProgress.unlockedContent?.includes(set.id);
              const isSecret = set.isMystery && !isOwned;
               if (isSecret) {
    return (
      <button 
        key={set.id}
        onClick={() => handleSetClick(set, isOwned)}  // ← MISMO onClick
        className="w-full rounded-3xl px-4 py-4 bg-gradient-to-r from-slate-900 to-indigo-900 border border-indigo-500/40 shadow-lg flex items-center justify-between active:scale-95 transition-all group"
      >
        <div className="flex items-center gap-3">
          <div className="w-12 h-12 rounded-2xl bg-black/30 flex items-center justify-center group-hover:scale-110 transition-transform">
            <span className="text-3xl text-amber-300 animate-pulse">❓</span>
          </div>
          <div className="text-left">
            <p className="text-sm font-black text-white tracking-wide uppercase">
              Set Misterioso
            </p>
            <p className="text-[11px] text-indigo-200/80">
              Desbloquea para revelar el tema
            </p>
          </div>
        </div>
        
        <div className={`px-3 py-1.5 rounded-full text-xs font-black flex items-center gap-1
          ${userProgress.xp >= set.cost 
            ? 'bg-white text-slate-900 shadow-[0_0_15px_rgba(255,255,255,0.5)]' 
            : 'bg-slate-800/50 text-slate-400 border border-slate-700'}`}>
          <Lock size={12} /> {set.cost} XP
        </div>
      </button>
    );
  }
  
              
             return (
  <div 
    key={set.id} 
    onClick={() => handleSetClick(set, isOwned)} 
    className={`p-5 rounded-[2.5rem] border-2 shadow-sm flex items-center gap-5 transition-all active:scale-95 cursor-pointer group relative overflow-hidden
      ${isOwned 
        ? 'bg-white border-slate-100 hover:border-green-400 hover:shadow-lg hover:shadow-green-100' 
        : 'bg-white border-slate-100 hover:border-indigo-400 hover:shadow-lg'}`}
  >
    {/* ✅ Barra lateral: solo dos opciones (verde si owned, gris si no) */}
    <div className={`absolute left-0 top-0 bottom-0 w-2 ${isOwned ? 'bg-green-500' : 'bg-slate-200'}`} />

    {/* ✅ Icono: solo dos opciones */}
    <div className={`w-16 h-16 rounded-3xl flex items-center justify-center text-3xl border-2 shrink-0 transition-transform group-hover:scale-110 duration-300
      ${isOwned 
        ? 'bg-green-50 border-green-100 shadow-inner' 
        : 'bg-slate-50 border-slate-100 group-hover:bg-indigo-50 shadow-inner'}`}>
      {set.emoji}  {/* ✅ Ya no necesitas verificar isSecret */}
    </div>

    {/* ✅ Textos: solo dos opciones */}
    <div className="flex-1 min-w-0">
      <h4 className={`font-black text-lg leading-tight truncate ${isOwned ? 'text-slate-800' : 'text-slate-800'}`}>
        {set.title}  {/* ✅ Siempre muestra el título real */}
      </h4>
      <p className={`text-xs mt-1 font-bold truncate ${isOwned ? 'text-slate-400 uppercase tracking-tighter' : 'text-slate-400 uppercase tracking-tighter'}`}>
        {set.description}  {/* ✅ Siempre muestra la descripción real */}
      </p>
    </div>

    {/* ✅ Badge: este se mantiene igual */}
    {isOwned ? (
      <div className="bg-green-500 text-white p-3 rounded-2xl shadow-lg shadow-green-200 group-hover:rotate-12 transition-transform">
        <BookOpen size={20} fill="currentColor" />
      </div>
    ) : (
      <div className={`px-4 py-2 rounded-2xl text-sm font-black flex items-center gap-2 border-b-4 transition-all
        ${(userProgress.xp >= set.cost) 
          ? 'bg-slate-800 text-white border-slate-950 group-hover:bg-indigo-600 group-hover:border-indigo-800' 
          : 'bg-slate-100 text-slate-400 border-slate-200'}`}>
        <Zap size={14} fill="currentColor" className={userProgress.xp >= set.cost ? 'text-amber-400' : 'text-slate-300'} /> 
        {set.cost}
      </div>
    )}
  </div>
);

            })}
          </div>
        </div>
      </div>

      {/* MODALES */}
      <SetViewerModal 
        viewingSet={viewingSet}
        onClose={() => setViewingSet(null)}
        onStartPractice={onStartPractice}
        onStartChallenge={onStartChallenge}
        playSound={playSound}
        zIndex={1000}
      />
    </div>
  );
}


  // =========================================================
  // MODO TIENDA: Modal flotante (estilo XpModal)
  // =========================================================
  return (
  <>
    {purchaseSuccess && <ConfettiEffect />}

    <div 
      onClick={handleOverlayClick}
      className="fixed inset-0 bg-black/60 backdrop-blur-sm flex items-end sm:items-center justify-center p-4 animate-in fade-in duration-300"
      style={{ zIndex: Z_INDEX.SHOP_MODAL }}
    >
      <div 
        onClick={(e) => e.stopPropagation()}
        className="bg-white w-full max-w-lg rounded-[2.5rem] shadow-2xl overflow-hidden max-h-[90vh] flex flex-col animate-in slide-in-from-bottom-10 duration-500 relative"
      >
        {/* HEADER CON MASCOTA INTEGRADA */}
        <div className="bg-indigo-600 p-6 relative text-white text-center shrink-0">
          {/* ✅ MASCOTA DENTRO DEL HEADER - NO SE CORTA */}
          <div className="absolute top-2 right-20 w-20 h-20 pointer-events-none z-10">
            <Mascot type={currentSkin} />
          </div>

          <button 
            onClick={() => setView('lobby')} 
            className="absolute top-4 right-4 p-2 bg-white/20 rounded-full hover:bg-white/40 transition-colors z-10"
          >
            <X size={20} />
          </button>

          <div className="text-center mt-2">
            <h1 className="text-2xl font-black tracking-tight">Tienda de Saber</h1>
            <p className="text-indigo-200 font-medium text-sm">Sets y Sorpresas</p>
          </div>

          <div className="absolute top-6 left-6 flex items-center gap-1 bg-black/20 px-3 py-1 rounded-full">
            <Zap size={14} className="text-yellow-400" fill="currentColor" />
            <span className="font-bold text-sm">{userProgress.xp}</span>
          </div>
        </div>

          {/* CONTENIDO SCROLLABLE */}
          <div className="flex-1 overflow-y-auto p-6 bg-slate-50 space-y-6">
            {/* COFRE SORPRESA */}
            <div>
              <h3 className="text-sm font-black text-slate-400 uppercase tracking-widest mb-3">Skins y Sorpresas</h3>
              
              <div className="bg-gradient-to-br from-amber-400 to-orange-500 p-6 rounded-[2rem] text-white shadow-xl relative overflow-hidden text-center transform transition-all hover:scale-[1.02]">
                <div className="relative z-10">
<Gift size={56} className="mx-auto mb-4 drop-shadow-md group-hover:scale-110 transition-transform" />
                  <h2 className="text-2xl font-black mb-1">Cofre Sorpresa</h2>
                  <p className="text-orange-100 text-xs font-bold mb-4 px-4">
                    ¡Gana skins exclusivas o temas raros!
                  </p>
                 <button 
  onClick={() => setActiveModal({ type: 'CHEST' })} // ✅ Disparador global
  className="bg-white text-orange-600 px-8 py-3 rounded-2xl font-black text-sm shadow-lg hover:bg-orange-50 active:scale-95 transition-all"
>
  ABRIR x {CHEST_COST} XP
</button>
                </div>
              </div>
            </div>

            {/* LISTA DE SETS */}
            <div className="animate-in slide-in-from-bottom-10 duration-500">
              <h3 className="text-slate-800 font-black text-lg mb-4 flex items-center gap-2">
                <Star size={20} className="text-indigo-500" fill="currentColor" />
                Sets de Vocabulario
              </h3>
              <div className="space-y-4">
                {filteredSets.map((set) => {
                  const isOwned = set.cost === 0 || userProgress.unlockedContent?.includes(set.id);
                  const isSecret = set.isMystery && !isOwned;
                  return (
                    <div 
                      key={set.id} 
                      onClick={() => handleSetClick(set, isOwned)} 
                      className={`p-4 rounded-3xl border-2 shadow-sm flex items-center gap-4 transition-all active:scale-95 cursor-pointer group
                        ${isOwned ? 'bg-white border-green-100 hover:border-green-300' 
                          : isSecret ? 'bg-slate-800 border-slate-700 hover:border-indigo-500' 
                          : 'bg-white border-slate-100 hover:border-indigo-200'}`}
                    >
                      <div className={`w-14 h-14 rounded-2xl flex items-center justify-center text-3xl border shrink-0
                        ${isOwned ? 'bg-green-50 border-green-100' 
                          : isSecret ? 'bg-slate-700 border-slate-600 text-slate-400 animate-pulse' 
                          : 'bg-slate-50 border-slate-100 group-hover:bg-indigo-50'}`}>
                        {isSecret ? '❓' : set.emoji}
                      </div>

                      <div className="flex-1 min-w-0">
                        <h4 className={`font-bold leading-tight truncate ${isSecret ? 'text-indigo-300 italic tracking-widest' : 'text-slate-800'}`}>
                          {isSecret ? 'SET MISTERIOSO' : set.title}
                        </h4>
                        <p className={`text-xs mt-1 truncate ${isSecret ? 'text-slate-500' : 'text-slate-400'}`}>
                          {isSecret ? 'Desbloquea para revelar...' : set.description}
                        </p>
                      </div>

                      {isOwned ? (
                        <div className="bg-green-100 text-green-600 p-2 rounded-full shrink-0">
                          <BookOpen size={20} />
                        </div>
                      ) : (
                        <div className={`px-3 py-1.5 rounded-xl text-xs font-black flex items-center gap-1 shrink-0
                          ${(userProgress.xp >= set.cost) 
                            ? (isSecret ? 'bg-indigo-500 text-white shadow-lg' : 'bg-slate-800 text-white group-hover:bg-indigo-600') 
                            : 'bg-slate-100 text-slate-400'}`}>
                          <Lock size={12} /> {set.cost}
                        </div>
                      )}
                    </div>
                  );
                })}

                {filteredSets.length === 0 && (
                  <div className="bg-slate-100 p-8 rounded-[2.5rem] text-center border-2 border-dashed border-slate-200">
                    <p className="text-slate-400 font-bold">¡Ya compraste todo! 🎉</p>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* ========================= MODALES ========================= */}
      

      <SetViewerModal 
        viewingSet={viewingSet}
        onClose={() => setViewingSet(null)}
        onStartPractice={onStartPractice}
        playSound={playSound}
        zIndex={Z_INDEX.VIEWER}
      />
    </>
  );
}
